import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12 0C18.6274 0 24 5.37256 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12C0 5.37259 5.37259 0 12 0ZM12 1.5C6.21027 1.5 1.5 6.21026 1.5 12C1.5 17.7897 6.21027 22.5 12 22.5C17.7897 22.5 22.5 17.7897 22.5 12C22.5 6.21027 17.7897 1.5 12 1.5ZM16.7197 8.21973C17.0126 7.92683 17.4874 7.92683 17.7803 8.21973C18.0549 8.49431 18.0723 8.92905 17.832 9.22363L17.7803 9.28027L10.7803 16.2803C10.4979 16.5626 10.0482 16.5719 9.75488 16.3135L9.70215 16.2617L6.20215 12.5117C5.91959 12.209 5.93567 11.7348 6.23828 11.4521C6.52213 11.1872 6.95704 11.1844 7.24316 11.4346L7.29785 11.4883L10.2686 14.6709L16.7197 8.21973Z"
        fill="#B5D7F4"
      />
    </svg>
  );
}

export default Icon;
